<template>
  <b-modal
    id="add-object"
    cancel-variant="danger"
    :ok-title="$t('generals.add')"
    :cancel-title="$t('generals.cancel')"
    centered
    no-close-on-backdrop
    :title="$t('objects.add_new_object')"
    size="lg"
    @hidden="new_obj = { currency: 1 }"
    @ok="saveClick"
  >
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <custom-input
            v-for="(field, index) in newObjectFormFields"
            :key="index"
            v-model="new_obj[field.obj_name]"
            :component-name="field.component_name"
            :field-label="field.label"
            :field-props="field.props"
            :field-placeholder="field.placeholder"
            :validation-rules="field.validation_rules"
            :cols-size="field.colsSize"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BRow,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import customInput from '@/components/CustomValidatedInput.vue'
import toast from '@/mixins/toast'

export default {
  components: {
    BModal,
    BForm,
    ValidationObserver,
    BRow,
    customInput,
  },
  mixins: [toast],
  data() {
    return {
      new_obj: {
        currency: 1,
        object_type: 1,
      },
      currencyOptions: [
        { text: 'Сум', id: 1 },
      ],
    }
  },
  computed: {
    ...mapGetters('knowledgeBase', ['GET_REGIONS', 'GET_DISTRICTS', 'GET_CURRENCIES', 'GET_SALE_OFFICES', 'GET_CONSTRUCTORS']),
    ...mapGetters('objects', ['GET_OBJECT_TYPES']),
    getLocale() {
      const locale = this.$i18n.locale || 'uz'
      return locale
    },
    newObjectFormFields() {
      return [
        {
          obj_name: 'title',
          validation_rules: 'required',
          label: this.$t('objects.name_object'),
          placeholder: this.$t('objects.name_object'),
          props: {
            size: 'lg',
          },
        },
        {
          component_name: 'b-form-radio-group',
          obj_name: 'object_type',
          validation_rules: 'required',
          label: this.$t('objects.object_type'),
          placeholder: this.$t('objects.object_type'),
          props: {
            options: this.GET_OBJECT_TYPES,
            // buttons: true,
            'button-variant': 'outline-primary',
            'value-field': 'id',
            'text-field': `name.${this.$i18n.locale}`,
            class: 'mt-50',
          },
        },
        {
          component_name: 'v-select',
          colsSize: '4',
          obj_name: 'currency',
          validation_rules: 'required',
          label: this.$t('objects.currency'),
          placeholder: this.$t('objects.currency'),
          props: {
            options: this.GET_CURRENCIES,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.id,
            disabled: true,
          },
        },

        {
          component_name: 'v-select',
          colsSize: '8',
          obj_name: 'sale_office',
          label: this.$t('objects.sale_office'),
          placeholder: this.$t('objects.sale_office'),
          props: {
            label: 'title',
            options: this.GET_SALE_OFFICES,
            reduce: option => option.id,
          },
        },
        {
          component_name: 'v-select',
          colsSize: '6',
          obj_name: 'region',
          label: this.$t('objects.region'),
          placeholder: this.$t('objects.region'),
          props: {
            options: this.GET_REGIONS,
            getOptionLabel: option => option.name[this.getLocale],
            reduce: option => option.id,
          },
        },
        {
          component_name: 'v-select',
          colsSize: '6',
          obj_name: 'rayon',
          label: this.$t('objects.district'),
          placeholder: this.$t('objects.district'),
          props: {
            options: this.GET_DISTRICTS,
            getOptionLabel: option => option.name[this.getLocale],
            reduce: option => option.id,
            disabled: Boolean(!this.new_obj.region),
          },
        },
        {
          obj_name: 'brand',
          colsSize: '6',
          component_name: 'v-select',
          validation_rules: 'required',
          props: {
            options: this.GET_CONSTRUCTORS,
            label: 'title',
            reduce: option => option.id,
          },
          label: this.$t('objects.constructor_brand'),
          placeholder: this.$t('objects.constructor_brand'),
        },
        {
          obj_name: 'site',
          colsSize: '6',
          validation_rules: 'url',
          label: this.$t('objects.site'),
          placeholder: this.$t('objects.site'),
        },
      ]
    },
  },
  watch: {
    'new_obj.region': function () {
      this.FETCH_DISTRICTS({ region: this.new_obj.region })
    },
  },
  created() {
    this.FETCH_REGIONS({ region: 0, page_size: 15 })
    this.FETCH_DISTRICTS({ region: this.new_obj.region })
    this.FETCH_OBJECT_TYPES()
    this.FETCH_CURRENCIES()
    this.FETCH_SALE_OFFICES()
    this.FETCH_CONSTRUCTORS()
  },
  methods: {
    ...mapActions('knowledgeBase', ['FETCH_REGIONS', 'FETCH_DISTRICTS', 'FETCH_CURRENCIES', 'FETCH_SALE_OFFICES', 'FETCH_CONSTRUCTORS']),
    ...mapActions('objects', ['ADD_OBJECT', 'FETCH_OBJECT_TYPES']),
    saveClick(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const { region, rayon, ...rest } = this.new_obj
          const objData = {
            region: rayon || region,
            ...rest,
          }
          console.log(objData)
          this.ADD_OBJECT(objData).then(() => {
            this.$emit('saveSuccess')
            this.$_successToast(this.$t('generals.added'))
            this.$bvModal.hide('add-object')
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      }).catch(() => {
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
